import React from 'react';
import { Card, CardContent } from '../../ui/card';

// Stat cards use translucent dark-friendly tones so they render correctly
// inside the dark Admin portal AND on the original light dashboard.
const buildStats = ({ total, high, medium, onTrack, threshold, urgencyFilter }) => [
  { label: 'Needs Coaching', value: total, filter: null,
    cardClass: 'bg-white/5 dark:bg-white/5 border border-white/10',
    textClass: 'text-white', labelClass: 'text-white/50' },
  { label: 'High Priority', value: high, filter: 'high',
    cardClass: urgencyFilter === 'high'
      ? 'bg-rose-500/15 border-rose-400/60 ring-2 ring-rose-400/40'
      : 'bg-rose-500/10 border border-rose-400/30',
    textClass: 'text-rose-200', labelClass: 'text-rose-300/80' },
  { label: 'Medium Priority', value: medium, filter: 'medium',
    cardClass: urgencyFilter === 'medium'
      ? 'bg-amber-500/15 border-amber-400/60 ring-2 ring-amber-400/40'
      : 'bg-amber-500/10 border border-amber-400/30',
    textClass: 'text-amber-200', labelClass: 'text-amber-300/80' },
  { label: 'On Track', value: onTrack ?? 0, filter: 'on_track',
    cardClass: urgencyFilter === 'on_track'
      ? 'bg-emerald-500/15 border-emerald-400/60 ring-2 ring-emerald-400/40'
      : 'bg-emerald-500/10 border border-emerald-400/30',
    textClass: 'text-emerald-200', labelClass: 'text-emerald-300/80' },
];

export const CoachingStatsBar = ({ total, high, medium, onTrack, threshold, urgencyFilter, onUrgencyFilter }) => (
  <div className="grid grid-cols-2 sm:grid-cols-4 gap-4">
    {buildStats({ total, high, medium, onTrack, threshold, urgencyFilter }).map(s => {
      const isActive = s.filter && urgencyFilter === s.filter;
      const handleClick = s.filter ? () => onUrgencyFilter(isActive ? null : s.filter) : undefined;
      return (
        <Card
          key={s.label}
          className={`shadow-sm transition-all rounded-xl ${s.cardClass} ${s.filter ? 'cursor-pointer hover:bg-white/[0.08]' : ''}`}
          onClick={handleClick}
          data-testid={`coaching-stat-${s.label.toLowerCase().replace(/ /g, '-')}`}
        >
          <CardContent className="pt-5">
            <p className={`text-xs mb-1 font-medium uppercase tracking-wider ${s.labelClass}`}>{s.label}</p>
            <p className={`text-3xl font-bold ${s.textClass}`}>{s.value}</p>
            {s.filter && <p className="text-xs text-white/30 mt-1">{isActive ? 'Showing filtered ×' : 'Click to filter →'}</p>}
          </CardContent>
        </Card>
      );
    })}
  </div>
);
